<template>
  <div class="email">
    <EmailIcon :class="{ inactive: !active }" />
  </div>
</template>

<script>
import EmailIcon from '~/assets/svg/email.svg?component'

export default {
  components: {
    EmailIcon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass" scoped>
  .email
    :deep(svg)
      &.inactive
        path:nth-child(1)
          fill: #D1D1D1
          stroke: #D1D1D1
</style>
